import scrollTo from './scrollTo';
import ResizeTracker from 'utils/ResizeTracker';

class ScrollToHash {

    /**
     * @param {HTMLElement} element
     * @param {Object} options
     */
    constructor(element, options) {
        this._defaultOptions = {
            offset: 80,
            mobileOffset: 60,
            mobileSize: 768,
            timeout: 350,
            shortTimeout: 10
        };

        this._state = {
            isMobile: false
        };

        this._options = { ...options, ...this._defaultOptions };
        this._rootContainer = document.body;
        this._setIsMobile = this._setIsMobile.bind(this);
        this._cacheSelectors();
        this._initialize();
    }

    /**
     * Initialize
     * @private
     */
    _cacheSelectors() {
        const hashAttribute = this._options.hashAttribute ? this._options.hashAttribute : 'data-hash-scroll';
        this._hashes = [...this._rootContainer.querySelectorAll(`[${hashAttribute}]`)];
        this._header = this._rootContainer.querySelector('.header');
    }

    /**
     * Initialize
     * @private
     */
    _initialize() {
        this._resizeTracker = new ResizeTracker();

        this._resizeTracker.init(
            { element: this._rootContainer },
            this._setIsMobile
        );

        this._setIsMobile();
        this._hashLoadHandler();

        if (this._hashes) {
            this._hashes.forEach(targetElement => {
                targetElement.addEventListener('click', event => this._clickedHash(event, false));
                targetElement.addEventListener('keydown', event => this._handleBtnKeyDown(event));
            });
        }
    }


    _handleBtnKeyDown(event) {
        if (event.key === ' ' || event.key === 'Enter' || event.key === 'Spacebar') {
            this._clickedHash(event, true);
        }
    }

    /**
     * Handle clicked hash link
     * @private
     * @param {event} event
     * @param {boolean} shouldFocus
     */
    _clickedHash(event, shouldFocus) {
        const hash = event.target.hash;
        if (this._options.delay) {
            const timeout = setTimeout(() => {
                const nextSection = shouldFocus && document.querySelector(hash);
                /* eslint-disable no-unused-expressions, no-magic-numbers */
                nextSection && nextSection.focus();
                /* eslint-enable */
                this._scrollToHash(hash);

                clearTimeout(timeout);
            }, parseInt(this._options.delay, 10));
        } else {
            this._scrollToHash(hash);
        }

    }

    /**
     * Scroll to hash
     * @private
     * @param {string} hash
     */
    _scrollToHash(hash) {
        const target = this._rootContainer.querySelector(hash);
        // eslint-disable-next-line curly
        if (!target) return;
        const isNavigation = hash === '#main';
        const pageTitle = isNavigation && document.querySelector('h1');

        /* eslint-disable no-unused-expressions, no-magic-numbers */
        pageTitle && pageTitle.focus();
        target && target.focus();
        /* eslint-enable */
        const topOffset = this._state.isMobile ? this._options.mobileOffset : this._options.offset;
        const targetBoundingBox = target.getBoundingClientRect();
        const offset = targetBoundingBox.top + document.documentElement.scrollTop - this._header.clientHeight - topOffset;

        scrollTo(null, offset);
    }

    /**
     * Check hash on load
     * @private
     */
    _hashLoadHandler() {
        const hash = window.location.hash;
        // eslint-disable-next-line curly
        if (!hash) return;
        const timeout = setTimeout(() => {
            this._scrollToHash(hash);
            clearTimeout(timeout);
        }, this._options.shortTimeout);
    }

    /**
     * Set mobile state
     * @private
     */
    _setIsMobile() {
        this._state.isMobile = this._rootContainer.clientWidth < this._options.mobileSize;
    }
}

export default ScrollToHash;
